import { useEffect, useState } from "react";

import { progressManager } from "./ProgressManager";

export function useProgressManager() {
    const [_tick, setTick] = useState(0);

    useEffect(() => {
        const unsubscribe = progressManager.subscribe(() => {
            setTick((t) => t + 1);
        });
        return unsubscribe;
    }, []);

    const addProgressHandler = () => {
        const id = crypto.randomUUID();
        progressManager.addProgress(id);

        return (value: number) => {
            progressManager.updateProgress(id, value);
        };
    };

    return {
        progresses: progressManager.getProgresses(),
        averageProgress: progressManager.getAverage(),
        shouldShowText: progressManager.shouldShowText(),
        addProgressHandler,
        resetProgress: () => progressManager.reset(),
    };
}
